import { withInstall, withNoopInstall } from '@sgui-plus/utils/with-install'

import Steps from './src/index.vue'
import Step from './src/item.vue'

export const SgSteps = withInstall(Steps, {
  Step,
})
export default SgSteps
export const SgStep = withNoopInstall(Step)
